// extracted by mini-css-extract-plugin
export default {"b-icon-warning":"Face_style_b-icon-warning__6-wwI","wrapper":"Face_style_wrapper__IdXBQ","content":"Face_style_content__zDsRe","rotate":"Face_style_rotate__bx6z8"};